export const H2 = 'mb-3.5 mt-0 text-[22px] font-extrabold tracking-tight text-slate-900';
export const EYEBROW = 'mb-3.5 mt-0 text-xs font-bold uppercase tracking-widest text-slate-500';

/** Every card sits below the band, full width, this far from what precedes it. */
export const CARD_GAP = 'mt-6';
